import { CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement, SubTitle, BarElement } from 'chart.js';

export const qualityColors = [
  'rgb(125,125,125)', /* 0_unknown */
  'rgb(54,235,63)', /* 1_good */
  'rgba(54, 162, 235, 1)', /* 2_ok */
  'rgb(235,123,54)', /* 3_bad */
  'rgb(235,54,54)', /* 4_terrible */
];

export const backgroundColor = [
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)'
];

export const borderColor = [
  'rgba(255, 99, 132, 0.2)',
  'rgba(54, 162, 235, 0.2)',
  'rgba(255, 206, 86, 0.2)',
  'rgba(75, 192, 192, 0.2)',
  'rgba(153, 102, 255, 0.2)',
  'rgba(255, 159, 64, 0.2)'
];

export const colors = [
  '#E05D5F',
  '#D77947',
  '#DA943F',
  '#E18B61',
  '#E1BC66',
  '#93B37A',
  '#519A84',
  '#568584',
  '#5E7487',
  '#94A2B0',
  '#38758F'
];

export const subTitleFont = {
  size: 12,
  family: "'Roboto', sans-serif",
  weight: 'bold'
};

export const titleFont = {
  size: 18,
  family: "'Roboto', sans-serif"
};

export const titleColor = 'rgba(189, 49, 86, 1)';

export const titlePadding = {
  top: 10,
  bottom: 10
};

export const register = [
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  SubTitle,
  Tooltip,
  Legend,
  ArcElement,
  BarElement
];
